const API = process.env.REACT_APP_API_URL;

const headers = (token) => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${token}`,
});

// =========================================================
// ACTIVE TEMPORARY CLOSURE REASONS
// =========================================================

export const GetActiveTemporaryClosureReasons = async (token) => {
  try {
    const response = await fetch(
      `${API}/TemporaryClosure/GetActiveTemporaryClosureReasons`,
      {
        method: "GET",
        headers: headers(token),
        credentials: "include",
      },
    );

    const text = await response.text();

    let data;
    try {
      data = text ? JSON.parse(text) : null;
    } catch {
      throw new Error("Invalid server response.");
    }

    if (!response.ok) {
      throw new Error(
        data?.messageFr ||
          data?.messageEn ||
          "Unable to retrieve temporary closure reasons.",
      );
    }

    return data;
  } catch (error) {
    console.error("GetActiveTemporaryClosureReasons error:", error);
    throw error;
  }
};

// =========================================================
// CREATE TEMPORARY CLOSURE
// =========================================================

// =========================================================
// POST - CREATE TEMPORARY CLOSURE
// =========================================================

export const CreateTemporaryClosure = async (token, payload) => {
  try {
    const response = await fetch(
      `${API}/TemporaryClosure/CreateTemporaryClosure`,
      {
        method: "POST",
        headers: headers(token),
        credentials: "include",
        body: JSON.stringify(payload),
      },
    );

    const text = await response.text();

    let data = null;

    try {
      data = text ? JSON.parse(text) : null;
    } catch (error) {
      console.error("CreateTemporaryClosure - Invalid JSON:", error);

      throw new Error("La réponse du serveur est invalide.");
    }

    if (!response.ok) {
      throw new Error(
        data?.messageFr ||
          data?.messageEn ||
          "Impossible d'enregistrer la fermeture temporaire.",
      );
    }

    return data;
  } catch (error) {
    console.error("CreateTemporaryClosure:", error);

    throw error;
  }
};
